import { observer } from 'mobx-react';
import React from 'react';
import { getDirectionFromVector } from './Map';
import MapBin from './MapBin';


@observer
class MapBlock extends React.Component {
  getDirection = () => {
    const { block } = this.props;
    return getDirectionFromVector(-block.FillDirection.X, -block.FillDirection.Y);
  };
  render() {
    const { block, direction } = this.props;
    if(!block.hasOwnProperty('Baseline')) return null;
    return <div className="map__block">
      {block.Bins.map(bin => !bin.Hidden && <MapBin key={bin.Id} bin={bin} block={block} direction={this.getDirection()} corridorDirection={direction} />)}
    </div>
  }
}

export default MapBlock;